import {
  GiftOption,
  GiftSectionFormValue,
} from "@/checkout/Sections/SubscriptionSection/types";

type GiftSelectionInput = {
  gifts?: GiftOption[] | null;
  giftSections?: GiftSectionFormValue[] | null;
};

const isSelectedGift = (gift: GiftOption | undefined): gift is GiftOption =>
  Boolean(gift?.selected);

export const getSelectedGiftsFromForm = ({
  gifts,
  giftSections,
}: GiftSelectionInput): GiftOption[] => {
  const selectedGiftsFromSections =
    giftSections
      ?.flatMap((section) => section.options)
      .filter(isSelectedGift) ?? [];
  const selectedStandaloneGifts = gifts?.filter(isSelectedGift) ?? [];

  return [...selectedGiftsFromSections, ...selectedStandaloneGifts];
};

export const getSelectedGiftSkusFromForm = (
  input: GiftSelectionInput,
): string[] =>
  getSelectedGiftsFromForm(input)
    .map(({ sku }) => sku)
    .filter((sku): sku is string => Boolean(sku));
